import { style } from 'typestyle'
export const pt16 = style({ paddingTop: '16px' })
